export const USERPLAN = 'usersPlan';
export const UNIVERSITYPLAN = 'universityPlan';
export const FREE = 'Free';
